import { autoinject, bindable } from 'aurelia-framework';
import { Map, renderMap } from './renderer';
import { MooringService } from 'services/mooring';
import './mooring-map-view.scss';
import { MapRenderOptions, MapFeatureOnClickArgs, OnAddServiceCorridor, MapTool } from './renderOptions';

@autoinject
export class MooringMapView {
  @bindable
  private mooringId: number;

  @bindable
  private onFeatureClick: (data: MapFeatureOnClickArgs) => void;

  @bindable
  private onAddServiceCorridor: OnAddServiceCorridor;

  private windowBus = new BroadcastChannel('mooring_map_bus');

  private activeTool: MapTool = 'none';

  private readonly renderOptions: MapRenderOptions = {
    showAnalysisNumbering: false,
    activeTool: 'none',
  };

  constructor(private mooringService: MooringService) {
    //
  }

  protected attached() {
    this.init();
  }

  protected activate({ mooringId }: { mooringId: number }) {
    this.mooringId = mooringId;
    this.init();
  }

  mapManager: Map;

  protected init() {
    void this.renderMap({ resetMap: true });
    this.windowBus.onmessage = (e) => {
      if (!e.isTrusted) return;
      if ((e.data as { map: string })['map'] === 'update') {
        this.starReRender();
      }
    };
  }

  protected timer = 0;
  protected starReRender(immediate = false) {
    window.clearTimeout(this.timer);
    this.timer = window.setTimeout(
      () => {
        void this.renderMap();
      },
      immediate ? 10 : 500
    );
  }

  protected async renderMap(opts: { resetMap?: boolean } = {}) {
    const { data } = await this.mooringService.getMooringDrawingSetup(this.mooringId);

    this.mapManager = renderMap(data, {
      renderOptions: this.renderOptions,
      onFeatureClick: this.onFeatureClick,
      onAddServiceCorridor: this.onAddServiceCorridor,
      resetMap: opts.resetMap ?? false,
    });
  }

  toggleShowAnalysisNumbering = (e: MouseEvent) => {
    const target = e.target as HTMLInputElement;
    this.renderOptions.showAnalysisNumbering = target.checked;
    this.starReRender(true);
  };

  resetCenter() {
    this.mapManager?.resetCenter();
  }

  detached() {
    this.windowBus.onmessage = null;
  }
}
